import { formatUptime } from './utils.js'

export default function MobiHeader({ status, connected, learning }) {
  const state = !connected
    ? 'DISCONNECTED'
    : status?.status === 'DREAMING'
      ? 'DREAMING'
      : status?.status || '—'
  return (
    <header className="mobi-header">
      <div className="mobi-header-brand">
        <h2 className="h-title">Möbi</h2>
        <span className="mobi-tagline">mathematical dreaming neural network</span>
      </div>
      <div className="mobi-header-meta">
        <span className={connected ? 'mobi-state' : 'mobi-state mobi-state-off'}>
          {state}
        </span>
        <span className="mobi-meta-item">
          GEN {status?.generation?.toLocaleString?.() ?? '—'}
        </span>
        <span className="mobi-meta-item dm-dim">
          {formatUptime(status?.uptime_seconds)}
        </span>
        {learning?.active_taste && (
          <span className="mobi-meta-item dm-dim">{learning.active_taste}</span>
        )}
      </div>
    </header>
  )
}
